import type { LangId } from "@aybuben/core/lang.ts";

import { en } from "./en.ts";
import { es } from "./es.ts";
import { ru } from "./ru.ts";

/** A `Record<LangId, …>` so a new language fails to compile until it has facts. */
export const FACTS: Record<LangId, readonly string[]> = { en, es, ru };
